import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { Box, CircularProgress, Drawer, Typography } from "@mui/material";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import addREC from "../../../../../assets/icons/addREC.svg";
import CompanyDashboardAddKeyResultsPopup from "./company-dashboard-initiative-drawer-side-bar-key-results-popup";
import { getProgressColor } from "../../../company-dashboard-utils";
import CompanyDashboardAddKeyResultsOwnerPopup from "./company-dashboard-initiative-drawer-side-bar-key-results-owner-popup";
import ownerImage from "../../../../../assets/icons/userProfileIcone.png";
import { getAllObjectives } from "../../../../../api/objectives";
import "./company-dashboard-initiative-drawer-side-bar.scss";
import UserDashboardAllObjectiveDrawer from "../../../../user-dashboard/user-dashboard-all-objective-drawer/user-dashboard-all-objective-drawer";
import CompanyDashboardAddExistingKeyResultsPopupMainComponent from "./company-dashboard-initiative-drawer-side-bar-add-existing-key-results-popup";
import { getKeyResults } from "../../../../../api/search-dashboard";

const CompanyDashboardInitiativeDrawerSideBarKeyResults: any = (props: any) => {// NOSONAR
  const {
    employeesList,
    // keyResultId,
    setKeyResultId,
    setIsAccordion,
    objectiveIdTooltip,
    objectiveId,
    fetchInitiatives,
    setAlertType,
    setAlertOpen,
    setLoading,
    setAlertMessage,
    statusListKeyResults,
    initiativeAPIData,
    updateInitiativeById,
    canEdit,
    canWrite,
    statusListObjectives,
    fetchInitiativeById,
    listKeyResultsData,
    setListKeyResultsData,
    setNewObjectiveData,
    dateFormat,
    existingKeyResultsData,
    fetchKeyResults,
    handleCreateInitiative,
    payloadData,
    canWriteInitiatives,
    initiativeDataPermissions,
    initiativeId,
  } = props;
  const [isOpenAddKeyResultsOwnerPopup, setIsOpenAddKeyResultsOwnerPopup] =
    useState(false);
  const [isOpenAddKeyResultsPopup, setIsOpenAddKeyResultsPopup] =
    useState(false);
  const [
    isOpenAddExistingKeyResultsPopup,
    setIsOpenAddExistingKeyResultsPopup,
  ] = useState(false);
  const [anchorElOwner, setAnchorElOwner] = React.useState<null | HTMLElement>(
    null,
  );
  const [selectedKeyResult, setSelectedKeyResult] = useState<any>(null);
  const [isShowUserObjectiveDrawer, setIsShowUserObjectiveDrawer] =
    useState(false);
  const [selectedApprover, setSelectedApprover] = useState<any>(null);

  const handleOpenOwnerMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElOwner(event.currentTarget);
  };

  const handleCloseOwnerMenu = () => {
    setAnchorElOwner(null);
  };

  useEffect(() => {
    setIsShowUserObjectiveDrawer(false);
  }, [initiativeId]);

  useEffect(() => {
    if (initiativeAPIData?.keyResults?.length) {
      setListKeyResultsData(
        initiativeAPIData?.keyResults?.map((keyResult: any) => {
          const objectIds =
            existingKeyResultsData?.find(
              (key: any) => key?.id === keyResult?.keyResultId,
            )?.objectiveId || [];
          return {
            id: keyResult.keyResultId,
            title: keyResult.keyResultTitle || keyResult.keyResultDescription,
            progress: keyResult.progressPercentage,
            weightage: keyResult.weight
              ? Math.round(keyResult.weight * 100) / 100
              : 0, //round up weightage in two decimal
            objectiveId: objectIds,
            status: keyResult.status || "Not Started",
            ownerName:
              keyResult.ownerName?.length > 0
                ? keyResult.ownerName?.map((owner: any) => {
                    const ownerData = employeesList?.find(
                      (emp: any) =>// NOSONAR 
                      emp.employeeFullName === owner,
                    );

                    return ownerData
                      ? {
                          id: ownerData?.employeeId,
                          name: ownerData?.employeeFullName,
                          label: ownerData?.employeeFullName,
                          profileImage: ownerData?.employeeImage || null,
                          role: ownerData?.roleName,
                          roleId: ownerData?.roleId,
                        }
                      : null;
                  })
                : [
                    {
                      id: null,
                      name: null,
                      label: null,
                      profileImage: ownerImage,
                      role: null,
                      roleId: null,
                    },
                  ],
          };
        }),
      );
    } else if (initiativeAPIData?.title) {
      setListKeyResultsData([]);
    }
  }, [initiativeAPIData, existingKeyResultsData]);
  const handleCloseAddKeyResultsPopup = () => {
    setIsOpenAddKeyResultsPopup(false);
    setSelectedKeyResult(null);
  };
  const handleCloseAddExistingKeyResultsPopup = () => {
    setIsOpenAddExistingKeyResultsPopup(false);
  };
  const canLinkExistingKeyResults =
    canWriteInitiatives && (initiativeDataPermissions || !initiativeId);

  const hasKeyResults = (listKeyResultsData?.length || 0) > 0;

  const handleOpenExistingKeyResultsPopup = () => {
    if (!canLinkExistingKeyResults) return;
    setIsOpenAddExistingKeyResultsPopup(true);
  };

  const handleOpenAddKeyResultsOwnerPopup = () => {
    setIsOpenAddKeyResultsOwnerPopup(true);
  };
  const handleCloseAddKeyResultsOwnerPopup = () => {
    setIsOpenAddKeyResultsOwnerPopup(false);
    setSelectedKeyResult(null);
  };

  const getDefaultOwner = () => ({
    id: null,
    name: null,
    label: null,
    profileImage: ownerImage,
    role: null,
    roleId: null,
  });

  const mapOwnersById = (owners: any[] = []) => {
    if (!owners.length) {
      return [getDefaultOwner()];
    }

    return owners
      .map((owner: any) => {
        const ownerData = employeesList?.find(
          (emp: any) => emp.employeeId === owner?.ownerId,
        );

        return ownerData
          ? {
              id: ownerData?.employeeId,
              name: ownerData?.employeeFullName,
              label: ownerData?.employeeFullName,
              profileImage: ownerData?.employeeImage || null,
              role: ownerData?.roleName,
              roleId: ownerData?.roleId,
            }
          : null;
      })
      .filter(Boolean);
  };

  const mapObjectiveDetails = (objectiveIds: any[] = [], objectives: any[] = []) => {
    return objectiveIds.map((objId: any) => {
      const objective = objectives.find((obj: any) => obj?.objectiveId === objId);
      return {
        objectiveName: objective?.objectiveName || "",
        startDate: dayjs(objective?.lastUpdated).format(dateFormat) || "",
        weightage: objective?.progress || 0,
        objectiveId: objective?.objectiveId || null,
        status: objective?.status || "Not Started",
      };
    });
  };

  const mapNewKeyResultItem = (
    keyResultIdData: any,
    keyResults: any[] = [],
    objectives: any[] = [],
  ) => {
    const keyResult =
      keyResults.find((item: any) => item?.pk === keyResultIdData?.keyResultId) ||
      null;

    if (!keyResult?.pk) {
      return { row: null, objectiveDetails: [] };
    }

    const objectiveDetails = mapObjectiveDetails(
      keyResult?.objectiveId || [],
      objectives,
    );

    return {
      row: {
        id: keyResult.pk,
        title: keyResult.title || "",
        progress: keyResult.progress,
        weightage: keyResult.weightage || "0",
        status: keyResult.status || "Not Started",
        objectiveId: keyResult?.objectiveId,
        ownerName: mapOwnersById(keyResult.keyResultowners || []),
      },
      objectiveDetails,
    };
  };

  const handleNewCreateKeyResult = async (newKeyResult: any) => {
    try {
      setLoading(true);
      const resKeyResult = await getKeyResults();
      const resObjectives = await getAllObjectives({});
      const keyResults = resKeyResult?.data?.data || [];
      const objectives = resObjectives?.data?.data || [];
      const allObjectives: any[] = [];
      const mappedRows: any[] = [];
      setKeyResultId();
      setKeyResultId(newKeyResult);

      newKeyResult?.forEach((keyResultIdData: any) => {
        const { row, objectiveDetails } = mapNewKeyResultItem(
          keyResultIdData,
          keyResults,
          objectives,
        );

        if (row) {
          mappedRows.push(row);
          allObjectives.push(...objectiveDetails);
        }
      });

      setListKeyResultsData(mappedRows);
      setNewObjectiveData(allObjectives);
      setTimeout(() => {
        setLoading(false);
      }, 100);
    } catch {
      setLoading(false);
    }
  };

  const stringAvatar = (name: string, color?: string, styles?: any) => {
    return {
      sx: {
        ...styles,
        bgcolor: color || "#403c6f",
      },
      children:
        name?.split(" ")?.length > 1
          ? `${name?.split(" ")?.[0]?.[0]}${name?.split(" ")?.[1]?.[0]}`
          : `${name}`,
    };
  };
  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Key Results</div>
        {/* {keyResultId ? null : ( */}
        {hasKeyResults &&
        <Tooltip title={objectiveIdTooltip}>
          <button
            className={
              selectedKeyResult
                ? "company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
                : "company-dashboard-initiative-drawer-side-bar-content-header-add-icon"
            }
            onClick={handleOpenExistingKeyResultsPopup}
            style={{
              cursor: canLinkExistingKeyResults ? "pointer" : "not-allowed",
            }}
          >
            {canLinkExistingKeyResults && <img src={addREC} alt="edit" />}
          </button>
        </Tooltip>}
        {/* )} */}
      </div>

      {hasKeyResults ? (
        listKeyResultsData?.map((keyResult: any, index: number) => (
          <div
            key={index + 1}
            className="company-dashboard-initiative-drawer-side-bar-content-key-results"
            style={keyResult?.isSelected ? { border: "1px solid #6E6D92" } : {}}
          >
            <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content">
              <div>
                <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-main-label">
                  {keyResult?.title || ""}
                </div>
              </div>
              <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-graph">
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    value={100}
                    size={72}
                    thickness={6.2}
                    sx={{
                      color: getProgressColor(keyResult?.status).lightColor,
                    }}
                  />
                  <CircularProgress
                    variant="determinate"
                    value={keyResult?.progress || 0}
                    size={72}
                    sx={{
                      color: getProgressColor(keyResult?.status).mainColor,
                      position: "absolute",
                      left: 0,
                      "& .MuiCircularProgress-circle": {
                        strokeLinecap: "round",
                      },
                    }}
                    thickness={6.2}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="caption"
                      component="div"
                      sx={{ color: "#403C6F" }}
                    >{`${Math.round(keyResult?.progress || 0)}%`}</Typography>
                  </Box>
                </Box>
              </div>
            </div>
            <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content">
              {keyResult?.ownerName?.length > 0 ? (
                <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner">
                  <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-label">
                    Owner
                  </div>
                  <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-img">
                    <AvatarGroup
                      max={3}
                      spacing={7}
                      renderSurplus={() => (
                        <Avatar sx={{ fontSize: 14 }}>+</Avatar>
                      )}
                    >
                      {[keyResult?.ownerName?.[0]]?.map(
                        (ownerDataInfo: any, index: number) => (
                          <Tooltip
                            title={ownerDataInfo?.name || ""}
                            key={index + 1}
                          >
                            <Avatar
                              alt={ownerDataInfo?.name}
                              src={ownerDataInfo?.profileImage}
                              {...(!ownerDataInfo?.profileImage &&
                                stringAvatar(ownerDataInfo?.name))}
                              onClick={() => {
                                // Open user details drawer for this owner
                                setSelectedApprover({
                                  id: ownerDataInfo?.id, // make sure ownerDataInfo has an ID
                                  name: ownerDataInfo?.name,
                                });
                                setIsShowUserObjectiveDrawer(true);
                              }}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        ),
                      )}

                      {keyResult?.ownerName?.length > 1 && (
                        <Avatar
                          {...stringAvatar(
                            `${keyResult?.ownerName?.length - 1}`,
                            "#CFCEDA",
                          )}
                          onClick={handleOpenOwnerMenu}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      {canWrite && (
                        <Avatar
                          {...stringAvatar(``, "#CFCEDA", {
                            border: "1px solid #CFCEDA",
                            color: "#FFFF",
                            fontSize: "18px",
                          })}
                          onClick={() => {
                            setSelectedKeyResult(keyResult?.id);
                            handleOpenAddKeyResultsOwnerPopup();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          +
                        </Avatar>
                      )}
                    </AvatarGroup>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorElOwner}
                      keepMounted
                      open={Boolean(anchorElOwner)}
                      onClose={handleCloseOwnerMenu}
                    >
                      {keyResult?.ownerName?.map(
                        (ownerDataInfo: any, index: number) => (
                          <MenuItem
                            key={index + 1}
                            onClick={handleCloseOwnerMenu}
                          >
                            <Tooltip title={ownerDataInfo?.name || ""}>
                              <Avatar
                                alt={ownerDataInfo?.name}
                                src={ownerDataInfo?.profileImage}
                                {...(!ownerDataInfo?.profileImage &&
                                  stringAvatar(ownerDataInfo?.name))}
                                onClick={() => {
                                  setSelectedApprover({
                                    id: ownerDataInfo?.id,
                                    name: ownerDataInfo?.name,
                                  });
                                  setIsShowUserObjectiveDrawer(true);
                                }}
                                style={{ cursor: "pointer" }}
                              />
                            </Tooltip>
                          </MenuItem>
                        ),
                      )}
                      {canWrite && (
                        <MenuItem
                          onClick={() => {
                            handleCloseOwnerMenu();
                            handleOpenAddKeyResultsOwnerPopup();
                            setSelectedKeyResult(keyResult?.id);
                          }}
                        >
                          <Avatar
                            {...stringAvatar(``, "#FFFF", {
                              border: "1px dotted #BAB9B6",
                              color: "#403C6F",
                              fontSize: "14px",
                            })}
                          >
                            +
                          </Avatar>
                        </MenuItem>
                      )}
                    </Menu>
                  </div>
                </div>
              ) : (
                <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner">
                  <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-label">
                    Owner
                  </div>
                  <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-img">
                    <img src={ownerImage} alt="Owner" />
                  </div>
                </div>
              )}
              <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner">
                <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-label">
                  Weight
                </div>
                <div
                  className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-label"
                  style={{ marginTop: "14px" }}
                >
                  {keyResult?.weightage || 0}%
                </div>
              </div>
              <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner">
                <div className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-label">
                  Action
                </div>
                <div
                  className="company-dashboard-initiative-drawer-side-bar-content-key-results-content-owner-label"
                  style={{ marginTop: "14px" }}
                >
                  <button
                    className={
                      "company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
                    }
                    onClick={() => {
                      if (!canEdit) return;
                      setIsOpenAddKeyResultsPopup(true);
                      setSelectedKeyResult(keyResult?.id);
                    }}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      border: "none",
                      background: "none",
                      padding: 0,
                    }}
                  >
                    {canEdit && initiativeDataPermissions ? (
                      <img src={editIcons} alt="edit" />
                    ) : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results">
          <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content">
            <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content-label">
              You don't have any key results
            </div>
            {(canWriteInitiatives && initiativeDataPermissions) ||
            (canWriteInitiatives && !initiativeId) ? (
              <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content-button">
                <Tooltip title={objectiveIdTooltip}>
                  <button
                    onClick={() =>
                      (canWriteInitiatives && initiativeDataPermissions) ||
                      (canWriteInitiatives && !initiativeId)
                        ? setIsOpenAddExistingKeyResultsPopup(true)
                        : null
                    }
                    style={{
                      cursor:
                        (canWriteInitiatives && initiativeDataPermissions) ||
                        (canWriteInitiatives && !initiativeId)
                          ? "pointer"
                          : "not-allowed",
                    }}
                  >
                    Link Existing Key Results
                  </button>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
      {isOpenAddKeyResultsPopup ? (
        <CompanyDashboardAddKeyResultsPopup
          isOpenAddPopup={isOpenAddKeyResultsPopup}
          onCancel={handleCloseAddKeyResultsPopup}
          employeesList={employeesList}
          listKeyResultsData={listKeyResultsData}
          setListKeyResultsData={setListKeyResultsData}
          fetchInitiatives={fetchInitiatives}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
          statusListKeyResults={statusListKeyResults}
          objectiveId={objectiveId}
          setIsAccordion={setIsAccordion}
          setKeyResultId={setKeyResultId}
          keyResultId={selectedKeyResult}
          updateInitiativeById={updateInitiativeById}
          statusListObjectives={statusListObjectives}
          handleNewCreateKeyResult={handleNewCreateKeyResult}
          initiativeAPIData={initiativeAPIData}
          handleCreateInitiative={handleCreateInitiative}
          payloadData={payloadData}
          fetchInitiativeById={fetchInitiativeById}
        />
      ) : null}
      {isOpenAddExistingKeyResultsPopup ? (
        <CompanyDashboardAddExistingKeyResultsPopupMainComponent
          isOpenAddPopup={isOpenAddExistingKeyResultsPopup}
          onCancel={handleCloseAddExistingKeyResultsPopup}
          existingKeyResultsData={existingKeyResultsData}
          initiativeAPIData={initiativeAPIData}
          fetchInitiatives={fetchKeyResults}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setAlertMessage={setAlertMessage}
          setLoading={setLoading}
          fetchInitiativeById={fetchInitiativeById}
          handleNewCreateKeyResult={handleNewCreateKeyResult}
          listKeyResultsData={listKeyResultsData}
        />
      ) : null}
      {isOpenAddKeyResultsOwnerPopup ? (
        <CompanyDashboardAddKeyResultsOwnerPopup
          isOpenAddPopup={isOpenAddKeyResultsOwnerPopup}
          onCancel={handleCloseAddKeyResultsOwnerPopup}
          employeesList={employeesList}
          listKeyResultsData={listKeyResultsData}
          setListKeyResultsData={setListKeyResultsData}
          fetchInitiatives={fetchInitiatives}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
          statusListKeyResults={statusListKeyResults}
          objectiveId={objectiveId}
          setIsAccordion={setIsAccordion}
          setKeyResultId={setListKeyResultsData}
          keyResultId={selectedKeyResult}
          updateInitiativeById={updateInitiativeById}
          statusListObjectives={statusListObjectives}
        />
      ) : null}
      <Drawer
        anchor={"bottom"}
        open={isShowUserObjectiveDrawer}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          setIsShowUserObjectiveDrawer(false);
        }}
        slotProps={{
          paper: {
            sx: {
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              top: "auto", // reset default
              marginTop: "10px", // 👈 space from top - reduced from 40px to 10px
              minHeight: "91.9vh",
              maxHeight: "91.9vh",
            },
          },
        }}
      >
        <UserDashboardAllObjectiveDrawer
          onClose={() => setIsShowUserObjectiveDrawer(false)}
          approverId={selectedApprover?.id}
          setIsShowAllObjectiveDrawer={setIsShowUserObjectiveDrawer}
          // Pass whatever props you need for user-specific dashboard
        />
      </Drawer>
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarKeyResults;
